import Dexie from 'dexie';

class MyDatabase extends Dexie {
  constructor() {
    super('trendsCustomerKeywordsUploadsDatabase');
    this.version(1).stores({});
    this.open().catch((err) => {
      console.error('Failed to open trendsCustomerKeywordsUploadsDatabase database:', err);
    });
  }

  async createCustomerStore(customerId) {
    const customerStore = `${customerId?.replace('_', '')}_store`;
    const tableExists = this.tables.some((table) => table?.name === customerStore);

    if (!tableExists) {
      // Close the database before changing the schema
      await this.close();

      const currentVersion = this.verno;
      const newVersion = currentVersion + 1;

      // Increment the version and apply the new schema
      this.version(newVersion).stores({
        [customerStore]:
          '++id, created_on, email, error_message, is_deleted, is_shared, list_extension, list_name, list_type, status, updated_on',
      });

      // Reopen the database to apply the changes
      await this.open();
      console.log('New schema applied successfully for customer store:', customerStore);
    }

    return this.table(customerStore);
  }
}

const customerKeywordUploadDb = new MyDatabase();
export default customerKeywordUploadDb;
